import * as React from 'react';
import { Shopstory, ShopstoryMetadataProvider } from '@shopstory/core/react';
import { DemoShopstoryProvider } from '../../../shopstory/provider';
import { withLocale } from '../../../utils/hocs';
import useShopstoryData from './useShopStoryData';

export const ShopstoryBlock = withLocale((props) => {
  const { locale } = props;
  const contentfulShopstoryBlock = useShopstoryData(
    locale[0],
    props.undefined.contentful_id
  );
  const meta =
    contentfulShopstoryBlock?.fields?.shopStoryData.meta &&
    JSON.parse(contentfulShopstoryBlock?.fields?.shopStoryData.meta);
  const content =
    contentfulShopstoryBlock?.fields?.shopStoryData.content &&
    JSON.parse(contentfulShopstoryBlock?.fields.shopStoryData.content);

  return meta && content ? (
    <div className='w-screen bg-white'>
      <DemoShopstoryProvider>
        <ShopstoryMetadataProvider meta={meta}>
          <Shopstory content={content} />
        </ShopstoryMetadataProvider>
      </DemoShopstoryProvider>
    </div>
  ) : null;

  return null;
});
